import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { getFeatured, getLatest } from "@/utils/catalog";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieGrid from "@/components/feature/MovieGrid";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import HotRanking from "@/pages/home/components/HotRanking";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  usePageMeta(
    "豆花视频—高清影视资源精选与视频内容平台",
    "豆花视频为您提供丰富影视资源和各类视频内容，涵盖电影、电视剧、综艺等多种类型，满足用户多样化的视频观看需求。"
  );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(timer);
  }, []);

  const featured = getFeatured();
  const latest = getLatest(10);

  return (
    <>
      <HeroCarousel items={featured} loading={loading} />
      <CategoryEntries />

      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <SectionHeading
          title="新片速递"
          subtitle="最新上线的影视内容，第一时间为你呈现"
          moreTo="/category/movie"
          moreLabel="更多新片"
        />
        <MovieGrid
          items={latest}
          loading={loading}
          skeletonCount={10}
          emptyTitle="暂无推荐内容"
          emptyDescription="当前没有可展示的最新影视内容，稍后再来看看吧。"
        />
      </section>

      <HotRanking />

      <section className="w-full">
        <div className="w-full px-4 md:px-8 pt-12 md:pt-16">
          <div className="relative overflow-hidden rounded-lg bg-gradient-to-r from-primary-600 to-primary-500 px-6 md:px-12 py-10 md:py-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="relative z-10">
              <h2 className="text-xl md:text-3xl font-black text-background-50 mb-2">
                找片不迷路，从这里开始搜索
              </h2>
              <p className="text-background-50/85 text-sm md:text-base max-w-xl">
                输入片名、演员或类型关键词，快速定位你想看的影视内容，获取详细的影片信息与观看参考。
              </p>
            </div>
            <Link
              to="/search"
              className="relative z-10 shrink-0 flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-600 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line"></i>
              立即搜索
            </Link>
          </div>
        </div>
        <SiteIntro />
      </section>
    </>
  );
}